if (!customElements.get('ax-quizz-results')) {
  customElements.define('ax-quizz-results', class extends HTMLElement {
    constructor() {
      super();
      this.params = new URLSearchParams(window.location.search);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.updateContent();
      this.animateResult();
    }

    updateContent() {
      const contentEl = this.querySelector('.ax-quizz-results__content');
      if (!contentEl) return;

      let template = contentEl.dataset.template;
      if (!template) return;

      const matches = template.match(/\[(.*?)\]/g);
      if (matches) {
        for (const match of matches) {
          const paramKey = match.slice(1, -1);
          const paramValue = this.params.get(paramKey) || '';
          template = template.replaceAll(match, paramValue);
        }
      }

      contentEl.textContent = template;
    }

    animateResult() {
      const resultEl = this.querySelector('[data-result-value]');
      if (!resultEl) return;

      const resultParamValue = this.params.get('result');
      if (!resultParamValue) {
        resultEl.textContent = '0';
        return;
      }

      const rawValue = resultParamValue.replace(',', '.');
      const targetValue = parseFloat(rawValue);

      if (isNaN(targetValue)) {
        resultEl.textContent = resultParamValue;
        return;
      }

      const duration = 2500;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.floor(easedProgress * targetValue);
        resultEl.textContent = currentValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          resultEl.textContent = targetValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        }
      };

      requestAnimationFrame(animate);
    }
  });
}
